import React from 'react';

import './TagList.scss';
import TextBox from '../TextBox';
import Icon from 'Core/Components/Icon';

class TagList extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      enteredTag: ''
    };

    this.removeTag = this.removeTag.bind(this);
    this.addTag = this.addTag.bind(this);
  }

  handleChange (e) {
    const { onChange } = this.props;
    if (typeof onChange !== 'function') return;
    const { value } = e.target;
    onChange(value);
  }

  addTag (tag) {
    const { value, onChange } = this.props;
    if (typeof onChange !== 'function') return;
    const newValue = value ? value.concat(tag) : [tag];
    onChange(newValue);
  }

  removeTag (tag) {
    const { value, onChange } = this.props;
    if (typeof onChange !== 'function') return;
    const newValue = value.filter(currentTag => currentTag !== tag);
    onChange(newValue);
  }

  render () {
    const { handleChange, removeTag, addTag, props } = this;
    const { options, value, label, icon, className, allTags } = props;

    const isValidTag = (tagText) => /[a-zA-Z0-9][a-zA-Z0-9\-]+/.test(tagText);

    return (
      <div className="Field TagList">
        <div className="TagList-Header Field-Header">
          {!icon ? null : (
            <div className="Field-Icon">
              <Icon fa="tags" className="TagList-Icon"/>&nbsp;
            </div>
          )}
          {!label ? null : (
            <label className="TagList-Label Field-Label">{label}</label>
          )}
        </div>

        <div className={'Field-Input TagList-Field' + (className ? ' ' + className : '')}>
          {(!value || !value.length) ? <i style={{opacity:0.33}}>No Tags</i> : value.map(tag => (
            <span className="TagList-Tag" key={tag}>
              {tag}{' '}
              <Icon fa="times" onClick={() => removeTag(tag)}/>
            </span>
          ))}
        </div>

        {!allTags ? null : (
          <React.Fragment>
            <div className="TagList-Header Field-Header">
              <div className="Field-Icon">
                <Icon fa="tags" className="TagList-Icon"/>&nbsp;
              </div>
              <label className="TagList-Label Field-Label">All Tags</label>
            </div>
            <div>
              {allTags.map(tag => value && value.includes(tag) ? null : (
                <span className="TagList-Tag" key={tag}>
                  {tag}{' '}
                  <Icon fa="plus" onClick={() => addTag(tag)}/>
                </span>
              ))}
            </div>
          </React.Fragment>
        )}

        <div style={{ flexDirection: 'row', alignItems: 'center', marginTop: '-10px', marginLeft: '-5px', display: 'flex' }}>
          <TextBox icon="pencil" value={this.state.enteredTag} label="New Tag" onChange={(enteredTag) => this.setState({ enteredTag })}>
            <button disabled={!isValidTag(this.state.enteredTag)} onClick={() => { addTag(this.state.enteredTag); this.setState({ enteredTag: '' }); }}>
              <Icon fa="plus-circle"/>
            </button>
          </TextBox>
        </div>
      </div>
    );
  }
};

export default TagList;



// WEBPACK FOOTER //
// ./client/RLX/Forms/TagList/TagList.jsx